import styled from "styled-components"
import TitleHeader from "components/presenters/header/TitleHeader"
import MotibellLanding from "components/modules/motibell/MotibellLanding"

export default function MotibellLandingLayout() {
  return (
    <Layout>
      <HeaderWrapper>
        <TitleHeader title="도전 모티벨" isShare />
      </HeaderWrapper>
      <BodyWrapper>
        <MotibellLanding />
      </BodyWrapper>
    </Layout>
  )
}

const Layout = styled.div`
  height: 100vh;
  overflow: hidden;
`

const HeaderWrapper = styled.div`
  min-height: calc(100vw * (51 / 375));
  flex: 0 1 auto;
`

const BodyWrapper = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: scroll;
`
